import { useDispatch, useSelector } from "react-redux"
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, Menu, MenuItem } from "@mui/material";
import Pagination from '@mui/material/Pagination'
import Switch from '@mui/material/Switch'
import { Box } from '@mui/material';
import Form from 'react-bootstrap/Form'
import NoDataImg from '../../../assets/img/no-data.gif'
import Dropdown from 'react-bootstrap/Dropdown'
import Button from '@mui/material/Button'
import InputGroup from 'react-bootstrap/InputGroup'
import { v4 as uuidv4 } from 'uuid';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import NavBar from "../../structure/NavBar"
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { NavBarTop } from "../../structure/NavBarTop"
import { useCallback, useEffect, useState } from "react"
import { Link } from "react-router-dom";
import Utils from "../../constants/Utils"
import { updateTopHeader, updateLoading } from "../../../redux/features/common/commonSlice"
import urls from "../../constants/apiurl"
import { showDangerToast, showToast } from "../../constants/toaster"
import ApiCaller from "../../constants/ApiCaller"
const label = { inputProps: { 'aria-label': 'Size switch demo' } }
export const VideoUploadList = props => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [selectedVideoDetails, setSelectedVideoDetails] = useState({})
    const [page, setPage] = useState(1)
    const { formatDate } = Utils();
    const [callAPi, setCallAPi] = useState('')
    const [pagerecord, setPagerecord] = useState({
        totalItems: 0,
        pageNumber: 1,
        pageSize: 10,
        totalPages: 1
    })
    const dispatch = useDispatch()
    const userData = useSelector(state => state?.userData)
    const [datalist, setDatalist] = useState([])
    const LOADING_ENABLE = useSelector(state => state?.loading)
    const [sort_type, setSortType] = useState('createdAt')
    const [sort_order, setSortOrder] = useState(false)
    const [searchText, setSearchText] = useState("")
    const [statusDropdownText, setStatusDropdownText] = useState('Select Status')
    const [activeInActiveStatus, setActiveInActiveStatus] = useState(null)
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)


    const userPermisiions = useSelector(state => state?.permission)
    let currentModulePermission;
    let viewPermission = true;
    let activePermission = true;

    if (userPermisiions?.modules.length > 0) {
        currentModulePermission = userPermisiions.modules.find((element) => {
            if (element.moduleId === '9') {
                return element
            }
        })?.permissions
        viewPermission = currentModulePermission.find((element) => {
            if (element.name === 'VIEW') {
                return element
            }
        }).isEnable
        activePermission = currentModulePermission.find((element) => {
            if (element.name === 'ACTIVE') {
                return element
            }
        }).isEnable
    }


    const handleChange = (event, value) => {
        setPage(value)
        setPagerecord({
            totalItems: pagerecord?.totalItems,
            totalPages: pagerecord?.totalPages,
            pageNumber: value,
            pageSize: 10
        })
        setCallAPi(uuidv4())
    }

    const handleClick = (event, item) => {
        setAnchorEl(event.currentTarget);
        setSelectedVideoDetails(item)
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        dispatch(updateTopHeader('Video Upload Manager'))
    })

    useEffect(() => {
        if (viewPermission) {
            getVideoList()
        }
    }, [callAPi])

    const getVideoList = async () => {
        let startDateObject;
        let endDateObject;
        if (startDate?.toDate()) {
            let newDate = new Date(startDate?.toDate());
            newDate.setDate(newDate.getDate() + 1);
            startDateObject = newDate;
        }
        if (endDate?.toDate()) {
            let newDate = new Date(endDate?.toDate());
            newDate.setDate(newDate.getDate() + 1);
            endDateObject = newDate;
        }
        try {
            dispatch(updateLoading(true))
            let postJson = {
                page: pagerecord?.pageNumber - 1 || 0,
                limit: pagerecord.pageSize || 10,
                sort: sort_type,
                order: sort_order,
                searchTxt: searchText?.trim(),
                videoType: true,
                active: activeInActiveStatus,
                startDate:
                    startDateObject !== null
                        ? startDateObject
                        : '',
                endDate:
                    endDateObject !== null
                        ? endDateObject
                        : '',
            }
            let path = urls.botVideoList
            let res = await ApiCaller.post(postJson, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                setDatalist(response?.data?.items)
                setPagerecord({
                    totalItems: response?.data?.totalItems,
                    totalPages: response?.data?.totalPages,
                    pageNumber: pagerecord?.pageNumber,
                    pageSize: 10
                })
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    const handleStatusChange = async (event, id) => {
        try {
            dispatch(updateLoading(true))
            let path = urls.activeInActiveVideo + '?videoId=' + id
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                showToast(response?.message)
                getVideoList()
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    // Handle filter click
    const handleFilterClick = useCallback(() => {
        setPage(1);
        setPagerecord({
            ...pagerecord,
            pageNumber: 1
        })
        setCallAPi(uuidv4())
    }, [searchText, activeInActiveStatus, startDate, endDate]);

    const handleResetFilter = () => {
        setSearchText('')
        setStartDate(null)
        setEndDate(null)
        setStatusDropdownText("Select Status")
        setActiveInActiveStatus(null)
        setPage(1);
        setPagerecord({
            ...pagerecord,
            pageNumber: 1
        })
        setCallAPi(uuidv4())
    }


    return <>
        <>
            <NavBar />
            <div className='main-content'>
                <NavBarTop />
                <div className='header'>
                    <div className='logo'>
                        <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
                    </div>
                </div>
                <div className='container-fluid mt--7'>
                    <div className='row'>
                        {/* Hidden file input */}
                        <div className='col text-left'>
                            <div className='card shadow'>
                                <div className='card-header border-0'>
                                    <div className='row align-items-center text-left'>
                                        <div className='col'>
                                            <h3 className='mb-0'>Video Upload Manager</h3>
                                        </div>
                                        <div className='col text-right'>
                                            {userData.admin ? (
                                                // <Link
                                                //     to={`/video-upload-manager/upload`}
                                                //     className='btn btn-sm btn-primary text-white'
                                                // >
                                                //     <CloudUploadIcon className="mr-2" />
                                                //     Upload Videos
                                                // </Link>

                                                <button
                                                    onClick={() => alert("Currently bot account is in upgrade mode.")}
                                                    className='btn btn-sm btn-primary text-white'
                                                >
                                                    <CloudUploadIcon className="mr-2" />
                                                    Upload Videos
                                                </button>
                                            ) :
                                                <></>}
                                        </div>
                                    </div>
                                </div>
                                <div className='card-header border-0'>
                                    <div className='row align-items-center text-left'>
                                        <div className='col-md-3'>
                                            <InputGroup
                                                className='mb-2'
                                                style={{ borderRadius: '10px' }}
                                            >
                                                <Form.Control
                                                    value={searchText}
                                                    onChange={(e) => setSearchText(e.target.value)}
                                                    placeholder='Search by User Name or ID'
                                                    aria-label='Amount (to the nearest dollar)'
                                                />
                                            </InputGroup>
                                        </div>
                                        <div className='col-md-2 mb-2 '>
                                            <Dropdown>
                                                <Dropdown.Toggle
                                                    variant='success'
                                                    style={{
                                                        backgroundColor: 'white',
                                                        color: 'black',
                                                        border: '1px solid #cad1d7',
                                                        boxShadow: 'none',
                                                        transform: 'none'
                                                    }}
                                                    id='dropdown-basic'
                                                >
                                                    {statusDropdownText}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item
                                                        onClick={() => {
                                                            setStatusDropdownText('Select Status')
                                                            setActiveInActiveStatus(null)
                                                        }
                                                        }
                                                    >
                                                        Select Status
                                                    </Dropdown.Item>
                                                    <Dropdown.Item
                                                        onClick={() => {
                                                            setStatusDropdownText('Active')
                                                            setActiveInActiveStatus(true)
                                                        }}
                                                    >
                                                        Active
                                                    </Dropdown.Item>
                                                    <Dropdown.Item
                                                        onClick={() => {
                                                            setStatusDropdownText('In Active')
                                                            setActiveInActiveStatus(false)
                                                        }}
                                                    >
                                                        In Active
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                        <div
                                            className='col-md-6 mb-3'
                                            style={{ marginLeft: '20px' }}
                                        >
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DemoContainer
                                                    components={['DatePicker', 'DatePicker']}
                                                >
                                                    <DatePicker
                                                        disableFuture
                                                        className='custom-date'
                                                        label='From Date'
                                                        value={startDate}
                                                        onChange={newValue => setStartDate(newValue)}
                                                        maxDate={endDate}
                                                    />
                                                    <DatePicker
                                                        disableFuture
                                                        label='To Date'
                                                        value={endDate}
                                                        minDate={startDate}
                                                        onChange={newValue => setEndDate(newValue)}
                                                    />
                                                </DemoContainer>
                                            </LocalizationProvider>
                                        </div>
                                        <div className='col-md-3 mb-2'>
                                            <Button
                                                variant='contained'
                                                className='custom-filter-btn'
                                                onClick={handleFilterClick}
                                            >
                                                Filter
                                            </Button>
                                            <Button
                                                variant='contained'
                                                className='ml-2 custom-filter-btn'
                                                onClick={handleResetFilter}
                                            >
                                                Reset
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                                <div className='table-responsive'>
                                    {datalist?.length ? (
                                        <>
                                            <table className='table align-items-center table-flush'>
                                                <thead className='thead-light'>
                                                    <tr>
                                                        <th scope='col'>S/No.</th>
                                                        <th scope='col'>User ID</th>
                                                        <th scope='col'>User Name</th>
                                                        <th scope='col'>Mobile No.</th>
                                                        <th scope='col'> Video Link</th>
                                                        <th scope='col'>No. Of Likes</th>
                                                        <th scope='col'>No. Of Comments</th>
                                                        <th scope='col'>Reports</th>
                                                        <th scope='col'>Date</th>
                                                        <th scope='col'>Status</th>
                                                        <th scope='col'>Action</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {datalist?.map((data, i) => {
                                                        const startIndex = (pagerecord.pageNumber - 1) * pagerecord.pageSize;
                                                        return (
                                                            <>
                                                                <tr key={i}>
                                                                    <td>{startIndex + i + 1}</td>
                                                                    <td>
                                                                        {data?.profileDetails?.userRecordId}
                                                                    </td>
                                                                    <td>{data?.profileDetails?.userName}</td>
                                                                    <td>{data?.profileDetails?.mobile}</td>
                                                                    <td className='truncate'>
                                                                        <a target='_blank' href={data?.link} rel="noreferrer">
                                                                            View
                                                                        </a>
                                                                    </td><>
                                                                        <td>{data?.totalLikes}</td>
                                                                        <td>{data?.totalComments}</td>
                                                                        <td>{data?.totalReports}</td>
                                                                        <td>{formatDate(data?.createdAt)}</td>
                                                                        <td>
                                                                            <Switch
                                                                                {...label}
                                                                                checked={data?.active}
                                                                                disabled={!activePermission}
                                                                                onChange={(e) => {
                                                                                    if (activePermission) {
                                                                                        handleStatusChange(e, data?.id)
                                                                                    }
                                                                                }
                                                                                }
                                                                                size='small'
                                                                            />
                                                                        </td>
                                                                        <td className='text-right'>
                                                                            <IconButton size="small" onClick={(e) => handleClick(e, data)}>
                                                                                <MoreVertIcon />
                                                                            </IconButton>
                                                                            <Menu
                                                                                anchorEl={anchorEl}
                                                                                open={open}
                                                                                onClose={handleClose}
                                                                                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                                                transformOrigin={{ vertical: "top", horizontal: "right" }}
                                                                            >
                                                                                {(userData.admin) && (
                                                                                    <MenuItem
                                                                                        onClick={() => setSelectedVideoDetails(data)}
                                                                                    >
                                                                                        View Details
                                                                                    </MenuItem>
                                                                                )}
                                                                            </Menu>
                                                                        </td>
                                                                    </>
                                                                </tr>
                                                            </>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </>
                                    ) : (
                                        <>
                                            <>
                                                <div className='text-center'>
                                                    <img width={'25%'} src={NoDataImg}></img>
                                                    <br />
                                                    <label style={{ fontWeight: 'bold' }}>
                                                        {LOADING_ENABLE ? (
                                                            <>Loading Data.....</>
                                                        ) : (
                                                            <>No Data Found</>
                                                        )}
                                                    </label>
                                                </div>
                                            </>
                                        </>
                                    )}
                                </div>
                                {datalist && datalist.length > 0 ? (
                                    <div className='card-footer py-4'>
                                        <Box display="flex" justifyContent="right" alignItems='center'>
                                            <span>Total record: {pagerecord?.totalItems}</span>
                                            <Pagination
                                                className='custom-pagination-class'
                                                count={pagerecord?.totalPages}
                                                page={page}
                                                onChange={handleChange}
                                                color='secondary'
                                            />
                                        </Box>
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                    </div>
                    {/* <Footer /> */}
                </div>

            </div>
        </>
    </>

}